import { gql, TypedDocumentNode } from "@apollo/client";

import {
  TemplateDeploymentChangeRecord,
  Maybe,
  PageInfo,
  QueryTemplateDeploymentArgs,
  SearchInput,
  TemplateDeploymentChangeRecordVersion,
  MutationTemplateDeploymentRollbackArgs,
  TemplateDeployment,
} from "types/generated";

import { InputSnapshot } from "./types";

export type ChangeHistoryVersionSnapshot = Pick<
  TemplateDeploymentChangeRecordVersion,
  "id" | "number" | "rawTemplate"
>;

export type ChangeHistoryRecord = Pick<TemplateDeploymentChangeRecord, "id" | "createdAt"> & {
  version: ChangeHistoryVersionSnapshot;
  previousVersion: Maybe<ChangeHistoryVersionSnapshot>;
  inputs: InputSnapshot[];
  previousInputs: Maybe<InputSnapshot[]>;
};

export type ChangeHistoryQueryData = {
  templateDeployment: {
    id: string;
    searchChangeHistory: {
      edges: Array<{ cursor: string; node: ChangeHistoryRecord }>;
      pageInfo: Pick<PageInfo, "hasNextPage" | "endCursor">;
    };
  };
};

type ChangeHistoryQueryVariables = QueryTemplateDeploymentArgs & {
  input: SearchInput;
};

type RollbackDeploymentMutationData = {
  templateDeploymentRollback: Maybe<Pick<TemplateDeployment, "id">>;
};

export const ROLLBACK_DEPLOYMENT: TypedDocumentNode<
  RollbackDeploymentMutationData,
  MutationTemplateDeploymentRollbackArgs
> = gql`
  mutation TemplateDeploymentRollback($templateID: ID!, $id: ID!, $changeRecordID: ID!) {
    templateDeploymentRollback(templateID: $templateID, id: $id, changeRecordID: $changeRecordID) {
      id
    }
  }
`;

export const CHANGE_HISTORY_QUERY: TypedDocumentNode<
  ChangeHistoryQueryData,
  ChangeHistoryQueryVariables
> = gql`
  query TemplateDeploymentChangeHistory($templateID: ID!, $id: ID!, $input: SearchInput!) {
    templateDeployment(templateID: $templateID, id: $id) {
      id
      searchChangeHistory(input: $input) {
        edges {
          cursor
          node {
            id
            createdAt
            version {
              id
              number
              rawTemplate
            }
            previousVersion {
              id
              number
              rawTemplate
            }
            inputs {
              id
              value
              secret
              checksum
            }
            previousInputs {
              id
              value
              secret
              checksum
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;
